import React from "react";
import { Box, Paper, Stack } from "@mui/material";
import Tramlines from "decodable-ui/lib/components/Tramlines";

export default function Fallback({ title, message, actions = null }) {
  return (
    <Box sx={{ display: "grid", placeItems: "center", padding: 6 }}>
      <Tramlines>
        <Paper sx={{ width: "auto" }}>
          <Stack alignItems="center" spacing={3} padding={3}>
            <Box
              component="h1"
              sx={{ fontSize: "2em", fontWeight: "700", margin: 0 }}
            >
              {title}
            </Box>
            <Box component="p" sx={{ color: "text.secondary" }}>
              {message}
            </Box>
            {actions && <Box>{actions}</Box>}
          </Stack>
        </Paper>
      </Tramlines>
    </Box>
  );
}
